import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./Button";
import { Strings } from "../Stores/StringsStore";

@observer
export class NextButton extends Button {

	render() {
		return <Button {...this.props} title={Strings.general.next}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<polygon points="14,0 24,16 14,32 8,32 18,16 8,0 " />
				</svg>
			</i>
		</Button>;
	}
}
